import type { DeviceType } from '@weberus/shared-types';
import { useSmartBanner } from '@weberus/ui/components/smart-banner/use-smart-banner';
import { redirectTo } from '@weberus/ui/utils/redirect';
import { makeDeepLink, type SmartBannerLink } from '@weberus/utils';
import { cn, RectangleButton, TextButton } from '@yanolja-rnd/nol-design-system';
import { IcClose } from '@yanolja-rnd/nol-icons';
import Modal from 'react-modal';

interface AppBannerPopupProps {
  deviceType: DeviceType;
  link?: SmartBannerLink;
  modalBaseClassName?: string;
  overlayBaseClassName?: string;
}
export const AppBannerPopup = ({ deviceType, link, modalBaseClassName, overlayBaseClassName }: AppBannerPopupProps) => {
  const { path, params, smartBannerOpen, onSmartBannerClose } = useSmartBanner(deviceType, link);

  const openDeepLink = () => {
    const deepLink = makeDeepLink({
      path: path || 'home',
      params,
      ...link,
    });

    redirectTo(deepLink, deviceType);
  };

  return (
    <Modal
      ariaHideApp={false}
      className={{
        afterOpen: '',
        base: cn(
          'relative z-[110] mx-16 mb-20 flex h-[21.8rem] w-full flex-col items-center rounded-24 bg-static-white pt-40 max-w-mobile-size',
          modalBaseClassName || '',
        ),
        beforeClose: '',
      }}
      closeTimeoutMS={210}
      isOpen={Boolean(smartBannerOpen)}
      onRequestClose={onSmartBannerClose}
      overlayClassName={{
        afterOpen: 'animate-overlayOpen',
        base: cn('fixed opacity-0 inset-0 bg-scrim z-[110] flex items-end justify-center', overlayBaseClassName || ''),
        beforeClose: '!animate-overlayClose',
      }}
    >
      <IcClose className="absolute left-16 top-16 cursor-pointer" onClick={onSmartBannerClose} />

      <img
        alt="내 여행 · 여가 앱으로 더 쉽게"
        height="60"
        src="https://yaimg.yanolja.com/web/images/common/app-banner/AppDownload_SVG_new.svg"
        width="248"
      />

      <div className="mb-4 mt-22 w-full px-40">
        <RectangleButton fullWidth onClick={openDeepLink} theme="outlined_primary" weight="bold">
          앱에서 보기
        </RectangleButton>
      </div>

      <TextButton mobileSize="small" onClick={onSmartBannerClose} theme="underline" weight="regular">
        오늘은 웹으로 볼게요
      </TextButton>
    </Modal>
  );
};
